import type { batchQueryAbWidgetQuery } from "scmp-app/queries/__generated__/batchQueryAbWidgetQuery.graphql";
import type { entityLink$key } from "scmp-app/queries/__generated__/entityLink.graphql";
import type { fallbackQueryLoaderQuery$data } from "scmp-app/queries/__generated__/fallbackQueryLoaderQuery.graphql";

export type MidPageQueueData = {
  packageTopEdges: MidPageQueueEdges;
  packageTopTopicName?: string;
  packageTopTopicReference: entityLink$key | null;
  storyPackageTwoEdges: MidPageQueueEdges;
  storyPackageTwoTopicName?: string;
  storyPackageTwoTopicReference: entityLink$key | null;
};

export type MidPageQueueEdges =
  | NonNullable<batchQueryAbWidgetQuery["response"]["widget1"]>["edges"]
  | NonNullable<batchQueryAbWidgetQuery["response"]["widget2"]>["edges"]
  | NonNullable<NonNullable<fallbackQueryLoaderQuery$data["packageTopQueue"]>["items"]>["edges"]
  | NonNullable<
      NonNullable<fallbackQueryLoaderQuery$data["storyPackageTwoQueue"]>["items"]
    >["edges"];

export const EMPTY_MID_PAGE_QUEUE_DATA: MidPageQueueData = {
  packageTopEdges: [],
  packageTopTopicReference: null,
  storyPackageTwoEdges: [],
  storyPackageTwoTopicReference: null,
};
